import {ITheme} from '../common/type';

export interface ICommentSection {
  id: number;
  isOpen: boolean;
  replyIds: number[];
  isEnd: boolean;
}
export interface ICommentContent {
  id: number;
  userName: string;
  userId: string;
  content: string;
  isBest: boolean;
  isReply: boolean;
  isSpolier: boolean;
  isWithdraw: boolean;
  isBlock: boolean;
  isMine: boolean;
  createDtText: string;
  type: ICommentType;
}
export interface IComment extends ICommentContent {
  likeCount: number;
  dislikeCount: number;
  replyCount: number;
  likeStatus: ICommentLikeStatus;
  parentId: number;
  episodeTitle?: string;
}

export type ICommentLikeStatus = 'none' | 'like' | 'dislike';
export type ICommentSort = 'createdDt' | 'like';
export type ICommentType =
  | 'authorMessage' // 작가의 말
  | 'normal'
  | 'temporary' // 임시조치
  | 'adminDelete'; // 클린센터에서 운영자에 의해 삭제

export enum ReportType {
  Spam = 'comment_report_spam', // 영리목적/홍보성
  Illegal = 'comment_report_illegal', // 불법정보
  Sexual = 'comment_report_sexual', // 음란성/선정성
  Violence = 'comment_report_violence', // 욕설/인신공격
  Privacy = 'comment_report_privacy', // 개인정보노출
  Repeatedly = 'comment_report_repeatedly', // 같은 내용 도배
  Etc = 'comment_report_etc', // 기타
  Right = 'comment_report_rights', // 권리침해
  Piracy = 'comment_report_piracy', // 불법촬영물
}
export const KOR_REPORT_TYPE = [ReportType.Right, ReportType.Piracy];

export interface ICommentList {
  ids: number[];
  sort: ICommentSort;
  sectionMap: {[id: number]: ICommentSection};
  commentMap: {[id: number]: IComment};
}

export interface ICommentTheme {
  commentBg: string;
  replyCommentBg: string;
  replyIconColor: 'grey' | 'white';
  isOnlyDarkModeBadge?: boolean;
  createDtTextStyle: string;
  spoilerTextStyle: string;
  spoilerInfoTextStyle: string;
  moreIconColor: 'grey' | 'white';
  buttonTheme: ICommentButtonTheme;
  deleteBtnTextStyle: string;
  replyMoreTextStyle: string;
  replyInputVariant?: ICommentInputVariant;
  emptyTextStyle?: string;
  temporaryTextStyle: string;
  temporaryUserNameTextStyle: string;
  userNameTextStyle: string;
  withdrawUserNameTextStyle?: string;
  contentTextStyle: string;
  commentDividerColor: string;
  replyDividerColor: string;
  inputWrapperStyle: string;
  inputWrapperStyleForReply: string;
  bestBadgeColor: 'white' | 'red';
}
export type ICommentBadgeType = 'creator' | 'best' | 'bestWhite';

interface ICommentButtonTheme extends IButtonStyle {
  effectStyle: {
    [key in ICommentButonEffect]: IButtonStyle;
  };
  smallDotVariant: 'black' | 'white';
}

export type ICommentButonEffect = 'color' | 'comment';
interface IButtonStyle {
  textStyle: string;
  bgStyle: string;
  bgStyleForReply: string;
}

export type ICommentInputVariant = 'darkGrey' | 'white';

export interface IUseCommentReturnValue {
  ids: number[];
  sort: ICommentSort;
  commentMap: {[id: number]: IComment};
  sectionMap: {[id: number]: ICommentSection};
  totalCount: number;
  fetchCommentsActionType: string;
  fetchCommentsFetchKey: number;
  fetchComments: (sort: ICommentSort, isFirst?: boolean) => void;
  fetchReplyComments: (parentId: number, isFirst?: boolean) => void;
  postComment: (content: string, isSpoiler: boolean) => void;
  postReplyComment: (parentId: number, content: string) => void;
  deleteComment: (commentId: number) => void;
  toggleSort: () => void;
  changeLikeStatus: (commentId: number, likeStatus: ICommentLikeStatus) => void;
  toggleReplyComments: (commentId: number, isOpen: boolean) => void;
}

export interface ICommentTrackingProps {
  section: string;
  page: string;
  contentId?: number;
  episodeId?: number;
  questCampaignId?: number;
  pageContentId?: number;
  pageEpisodeId?: number;
}

export interface IBanInfo {
  isPermanent: boolean;
  startDt: string;
  endDt: string;
}

export type IIconTheme = ITheme | 'white';
